export const pinPoints = (withTemplate) => {
  if (withTemplate) {
    return [
      'Always online',
      'Up to date with your business',
      'Connected to your email',
      'Friendly support',
      'Try 7 days for free'
    ];
  }

  return [
    'Always online',
    'Optimized for SEO',
    'Fully customizable',
    'Friendly support',
    'Try 7 days for free'
  ];
}

export const commonPinPoints = [
  'Build pretty buildings',
  'Design unique interiors',
  'Use plenty of stylish furniture',
  'Export to 3D and social media',
  'Easily collaborate on projects',
];

export const whyDungeonsPinPoints = [
  '4 Equipment pieces',
  'The Most Realistic Water™️',
  'Small but quite infinite world',
  '3 Frames per second',
  'Dinosaurs?',
  'Build grass everywhere',
];

export const treasureChestPinPoints = () => [
  'Up to 5mb upload',
  'Global delivery',
  'Instant three.js models and textures'
];

